import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { TitleMedium, ParagraphMediumText } from '../../../components/Texts';
import { PHONE_MEDIA_QUERY } from '../../../common/responsive';
import {
  sendEvent,
  sendMetaEvent,
  EVENT_SPEND_GALLERY_CARD_CLICKED,
} from '../../../common/analytics';

const CardContainer = styled.div`
  background-color: var(
    --section-bg,
    ${({ theme }) => theme.background.primary}
  );
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: transform 0.3s ease;
  cursor: pointer;
  border-radius: 8px;
  height: 100%;
  @media ${PHONE_MEDIA_QUERY} {
    flex: 0 0 calc((100vw - 48px) / 2.2);
    min-width: calc((100vw - 48px) / 2.2);
    max-width: calc((100vw - 48px) / 2.2);
  }
  @media (hover: hover) {
    &:hover {
      transform: translateY(-5px);
    }
  }
`;

const CardImageContainer = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: ${({ theme }) =>
    theme.background.secondary || theme.background.primary};
  overflow: hidden;
`;

const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const CardBody = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 5px 5px;
  text-align: left;
`;

const BrandName = styled(TitleMedium)`
  color: ${({ theme }) => theme.text.title};
  margin: 0;
  text-align: left;
`;

const PriceRange = styled(ParagraphMediumText)`
  color: ${({ theme }) => theme.text.secondary};
  margin: 0;
  text-align: left;
`;

const SpendGalleryGiftCard = ({
  card,
  priceRange,
  onClick,
  showPriceRange = true,
  showBrandName = true,
}) => {
  const navigate = useNavigate();
  const handleClick =
    onClick ||
    (() => {
      sendEvent(EVENT_SPEND_GALLERY_CARD_CLICKED, {
        gift_card_id: card.id,
        gift_card_brand: card.brand,
        gift_card_currency: card.currency,
      });
      sendMetaEvent('ViewContent', {
        content_ids: [String(card.id)],
        content_type: 'product',
        content_name: card.brand,
        currency: card.currency,
      });
      navigate(`/app/spend/${card.id}`);
    });

  return (
    <CardContainer onClick={handleClick}>
      <CardImageContainer>
        {card.card_image ? (
          <CardImage
            src={card.card_image}
            alt={card.brand}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        ) : null}
      </CardImageContainer>
      <CardBody>
        {showBrandName && <BrandName>{card.brand}</BrandName>}
        {showPriceRange && <PriceRange>{priceRange}</PriceRange>}
      </CardBody>
    </CardContainer>
  );
};

export default SpendGalleryGiftCard;
